import { render, staticRenderFns } from "./HospitalsClinics.vue?vue&type=template&id=58980324&"
import script from "./HospitalsClinics.vue?vue&type=script&lang=js&"
export * from "./HospitalsClinics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports